const ERRORS = {
  accountLocked: 'error_account_locked',
  credentials: 'error_credentials',
  email: 'error_email_invalid',
  emailNotVerified: 'error_email_verified',
  emailNotVerifiedReturnGeneric: 'error_email_verification_failed',
  emailNotVerifiedReturnInvalidActionCode: 'auth_action_email_expired',
  emailIncorrect: 'error_email_wrong',
  emailNotRecovered: 'auth_action_email_error',
  login: 'error_login',
  passwordLength: 'error_password_length',
  passwordAlphanumeric: 'error_password_alphanumeric',
  passwordCasemix: 'error_password_casemix',
  passwordRepeatedCharacters: 'error_password_repeated',
  passwordConsecutiveCharacters: 'error_password_consecutive',
  passwordContainsEmail: 'error_password_contains_email',
  passwordContainsNBX: 'error_password_contains_nbx',
  passwordCompromised: 'error_password_compromised',
  passwordsNotEqual: 'error_password_not_equal',
  passwordResetReturnInvalidActionCode: 'auth_action_email_expired',
  passwordResetReturnGeneric: 'auth_action_password_error',
  passwordWrong: 'error_password_wrong',
  sendEmailVerification: 'auth_verify_error',
  signup: 'error_signup',
  signup_email_already_used: 'error_signup_email_already_used',
  tooManyRequests: 'error_too_many_requests',
  twoFactor: 'auth_2fa_error',
  userLoginVerifyError: 'error_login_verify',
  verifyEmail: 'auth_verify_check_error',
  authRequiresRecentLogin: 'acc_err_authRequiresRecentLogin',
  authSecondFactorAlreadyInUse: 'acc_err_secondFactorAlreadyInUse',
  authInvalidPhoneNumber: 'acc_err_invalidPhoneNumber',
  authUnverifiedEmail: 'acc_err_unverifiedEmail',
  authInitFirebaseMfa: 'auth_init_firebase_mfa_error',
  authOperationNotAllowed: 'auth_operation_not_allowed',
  authSecondFactorRequired: 'auth_second_factor_required'
};

export default ERRORS;
